import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getCookieValue, LandingUrl, LandingHomeWithLangUrl } from '@repo/utils';
import { publicRuntimeConfig } from '@repo/config';
import LanguageDetector from 'i18next-browser-languagedetector';
import commonTranslations from './locales/common.json';
import enPhrase from './locales/en/phrase.json';
import arPhrase from './locales/ar/phrase.json';
import esPhrase from './locales/es/phrase.json';
import frPhrase from './locales/fr/phrase.json';
import hiPhrase from './locales/hi/phrase.json';
import idPhrase from './locales/id/phrase.json';
import kkPhrase from './locales/kk-KZ/phrase.json';
import koPhrase from './locales/ko/phrase.json';
import msPhrase from './locales/ms/phrase.json';
import ptPhrase from './locales/pt-BR/phrase.json';
import ruPhrase from './locales/ru/phrase.json';
import thPhrase from './locales/th/phrase.json';
import tlPhrase from './locales/tl/phrase.json';
import trPhrase from './locales/tr/phrase.json';
import ukPhrase from './locales/uk/phrase.json';
import zhPhrase from './locales/zh/phrase.json';
import viPhrase from './locales/vi/phrase.json';

const DEFAULT_NS = 'common';
export const DEFAULT_LANG = 'en';
export const I18N_COOKIE_NAME = 'i18next';

const getLanguage = () => {
  const languages = publicRuntimeConfig.languages.landingList;
  const currentPath = location.pathname;
  if (currentPath !== LandingUrl) {
    return undefined;
  }
  const cookieLanguage = getCookieValue(I18N_COOKIE_NAME);
  const referrer = document.referrer;
  if (cookieLanguage) {
    if (referrer.endsWith(LandingHomeWithLangUrl(cookieLanguage))) {
      return undefined;
    }
    if (languages.includes(cookieLanguage)) {
      return cookieLanguage;
    }
  }
  const browserLanguage = navigator.language.split('-')[0];
  if (languages.includes(browserLanguage)) {
    return browserLanguage;
  }
  return undefined;
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    // debug: true,
    supportedLngs: publicRuntimeConfig.languages.landingList,
    fallbackNS: DEFAULT_NS,
    defaultNS: DEFAULT_NS,
    ns: [DEFAULT_NS, 'phrase'],
    lng: getLanguage(),
    fallbackLng: DEFAULT_LANG,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        common: commonTranslations,
        phrase: enPhrase,
      },
      ar: {
        common: commonTranslations,
        phrase: arPhrase,
      },
      es: {
        common: commonTranslations,
        phrase: esPhrase,
      },
      fr: {
        common: commonTranslations,
        phrase: frPhrase,
      },
      hi: {
        common: commonTranslations,
        phrase: hiPhrase,
      },
      id: {
        common: commonTranslations,
        phrase: idPhrase,
      },
      'kk-KZ': {
        common: commonTranslations,
        phrase: kkPhrase,
      },
      ko: {
        common: commonTranslations,
        phrase: koPhrase,
      },
      ms: {
        common: commonTranslations,
        phrase: msPhrase,
      },
      pt: {
        common: commonTranslations,
        phrase: ptPhrase,
      },
      ru: {
        common: commonTranslations,
        phrase: ruPhrase,
      },
      th: {
        common: commonTranslations,
        phrase: thPhrase,
      },
      tl: {
        common: commonTranslations,
        phrase: tlPhrase,
      },
      tr: {
        common: commonTranslations,
        phrase: trPhrase,
      },
      uk: {
        common: commonTranslations,
        phrase: ukPhrase,
      },
      zh: {
        common: commonTranslations,
        phrase: zhPhrase,
      },
      vi: {
        common: commonTranslations,
        phrase: viPhrase,
      },
    },
    detection: {
      order: ['path', 'htmlTag'],
      caches: ['cookie'],
    },
  });
